import { Box, Typography } from '@mui/material';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import PropTypes from 'prop-types';

export const RightDrawer = ({ handleClose, title, children, actions, after = null }) => (
    <Box>
        <Box className='popup-wrapper popup-wrapper-top'>
            <Box className='popup-box popup-box--header'>
                <Typography variant='h4'>{title}</Typography>
                <Box className={actions ? 'popup-box__more-actions-grey' : undefined} sx={actions ? { height: '44px' } : undefined}>
                    {actions}
                    <CustomCloseButton onClose={handleClose} />
                </Box>
            </Box>
        </Box>
        <Box className='popup-wrapper border-bottom'>
            <Box className='popup-box'>{children}</Box>
        </Box>
        {after}
    </Box>
);

RightDrawer.propTypes = {
    handleClose: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    actions: PropTypes.node,
    after: PropTypes.node,
};
